import { render, staticRenderFns } from "./DTFAHome.vue?vue&type=template&id=434015c7&"
import script from "./DTFAHome.vue?vue&type=script&lang=js&"
export * from "./DTFAHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports